module.exports = __webpack_public_path__ + "static/img/menu_yh_on.40ad25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_yh_on.png
// module id = q9b/
// module chunks = 1